import { useState } from "react";
import { useNavigate } from "react-router-dom";
import QueryParameters from "../api/QueryParameters";
import { sendUnsubscribeRequest } from "../api/requests";
import { buildThankYouUrl } from "../views/ThankYou";
import Button from "./Button";

interface UnsubscribeProps {
  buttonLabel: string;
  confirmButtonLabel: string;
  confirmButtonUrl: string;
  thankYouLabel: string;
  errorMessage: string;
}

export default function UnsubscribeButton(props: UnsubscribeProps) {
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const onClickHandler = () => {
    const queryParams = new QueryParameters();
    setShowErrorMessage(false);
    setLoading(true);

    sendUnsubscribeRequest(queryParams)
      .then((status) => {
        if (status) {
          navigate(buildThankYouUrl(queryParams), {
            state: {
              label: props.thankYouLabel,
              buttonLabel: props.confirmButtonLabel,
              buttonUrl: props.confirmButtonUrl
            }
          });
        } else {
          setShowErrorMessage(true);
        }
      })
      .catch(() => {
        setShowErrorMessage(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Button
      buttonLabel={props.buttonLabel}
      errorMessage={props.errorMessage}
      onClick={onClickHandler}
      isLoading={isLoading}
      showErrorMessage={showErrorMessage}
    />
  );
}
